import DropdownPagination from './DropdownPagination';

export default DropdownPagination;
